import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './index.css'

// React Query ou Context Provider podem ser adicionados aqui
// import { QueryClient, QueryClientProvider } from 'react-query'
// import { AuthProvider } from './contexts/AuthContext'

// const queryClient = new QueryClient()

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    {/* <QueryClientProvider client={queryClient}>
      <AuthProvider> */}
        <App />
      {/* </AuthProvider>
    </QueryClientProvider> */}
  </React.StrictMode>
)
